import React from 'react';

import styles from './executiveManagementStyles';

import Executive from 'buyside/components/presentation/FundProfileShowPage/FundProfileSection/ExecutiveManagement/Executive/executive';

const ExecutiveManagement = ({ allocatorProfile }) => {
  const { executives } = allocatorProfile;
  return (
    <div className={styles.executivesList}>
      {executives.map((executive, index) => (
        <Executive key={index} executive={executive} />
      ))}
    </div>
  );
};

export default ExecutiveManagement;
